import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Inicio, { ModoInicio } from './Inicio.js';
import Clubes from './clubes/BaseClubes.js';
import DatosClub from './clubes/DatosClub.js';
import DatosEstadio from './estadios/DatosEstadio.js';
import DatosPersona from './personas/DatosPersona.js';
import Estadios from './estadios/BaseEstadios.js';
import FichaPartido from './partidos/FichaPartido.js';
import Geografia from './admin/AdminGeografia.js';
import HomeTorneos from './torneos/HomeTorneos.js';
import HomeTorneosInt from './torneos/HomeTorneosInt.js';
import HomeTorneosPaises from './torneos/HomeTorneosPaises.js';
import HomeTorneosSelec from './torneos/HomeTorneosSelec.js';
import Parametros from './admin/AdminParametros.js';
import Personas from './personas/BasePersonas.js';
import SeleccionesPais from './selecciones/BaseSeleccionesPais.js';
import RouterTorneos from './torneos/RouterTorneos.js';
// ...existing imports...
import { ARGENTINA } from './constantes/Paises.js';
import * as Filtros from './constantes/Filtros.js';
import * as DataSeguridad from './data/DataSeguridad.js';
import styles from './Menu.module.css';
import UserContext from '../context/UserContext.js';

const Menu = () => {
  const navigate = useNavigate();
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [modo, setModo] = useState(ModoInicio.NORMAL);
  const [estadoBackend, setEstadoBackend] = useState(false);
  const [suppressErrors, setSuppressErrors] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const validarBackend = async () => {
      try {
        const heartbeat = await DataSeguridad.Heartbeat();
        if (!cancelled) setEstadoBackend(heartbeat);
      } catch {
        // on error assume backend not available
        if (!cancelled) setEstadoBackend(false);
      }
    };

    // run immediately, then every 30s
    validarBackend();
    const timerId = setInterval(validarBackend, 30_000);

    return () => {
      cancelled = true;
      clearInterval(timerId);
    };
  }, []);

  useEffect(() => {
    const getUsuarioLogueado = async () => {
      let user = null;
      const logueado = await DataSeguridad.Authenticated();
      if (logueado) {
        user = await DataSeguridad.GetUsuario();
      }
      if (user !== null && user !== Promise.resolve(user)) {
        setUsuario(user);
      }
    };
    if (usuario === null && estadoBackend) {
      getUsuarioLogueado();
    } else if (!estadoBackend && usuario !== null) {
      // backend went down while user was logged -> treat as session expired
      setUsuario(null);
      setModo(ModoInicio.SESION_VENCIDAD);
      navigate('/nosession');
    }
  }, [usuario, estadoBackend, navigate]);

  const handlerLogout = () => {
    setModo(ModoInicio.LOGOUT);
    navigate('/');
  };

  const UsuarioLogueadoHandler = (usuario) => {
    setUsuario(usuario);
    setModo(ModoInicio.NORMAL);
    navigate('/');
  };

  const UsuarioDeslogueadoHandler = () => {
    setUsuario(null);
    setModo(ModoInicio.NORMAL);
  };

  const toggleSubmenu = () => {
    if (usuario !== null) {
      setShowSubmenu(!showSubmenu);
    }
  };

  const handleNavClick = async (e, to) => {
    // allow modified clicks (open in new tab) to behave normally
    if (
      !e ||
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    )
      return;
    e.preventDefault();

    // validate that the user is still authenticated before navigating
    let authenticated = false;
    try {
      authenticated = await DataSeguridad.Authenticated();
    } catch {
      authenticated = false;
    }

    if (authenticated) {
      navigate(to);
    } else {
      // session expired or not authenticated -> force local logout and send to login
      if (setSuppressErrors) setSuppressErrors(true);
      try {
        UsuarioDeslogueadoHandler();
      } catch {}
      navigate('/login');
      setTimeout(() => {
        if (setSuppressErrors) setSuppressErrors(false);
      }, 2000);
    }
  };

  const mostrarSubmenu = () => {
    if (!showSubmenu && usuario !== null) {
      setShowSubmenu(true);
    }
  };

  const ocultarSubmenu = () => {
    if (showSubmenu) {
      setShowSubmenu(false);
    }
  };

  const loginContext = {
    usuario: usuario,
    estadoBackend: estadoBackend,
    UsuarioLogueadoHandler: UsuarioLogueadoHandler,
    UsuarioDeslogueadoHandler: UsuarioDeslogueadoHandler,
    suppressErrors: suppressErrors,
    setSuppressErrors: setSuppressErrors,
  };

  //console.log("Menu", modo, usuario, loginContext, estadoBackend);

  return (
    <UserContext.Provider value={loginContext}>
      <div className={`${styles.main}`}>
        <ul className={`${styles.menu}`}>
          <li>
            <a href="/" onClick={(e) => handleNavClick(e, '/')}>
              Inicio
            </a>
          </li>
          <li
            className={`${usuario === null ? styles.submenuDisabled : styles.submenu}`}
            onMouseEnter={mostrarSubmenu}
            onMouseLeave={ocultarSubmenu}
            onClick={toggleSubmenu}
          >
            Argentina
            {showSubmenu && (
              <ul className={`${styles.submenuContent}`}>
                <a
                  href={'/torneosPais/' + ARGENTINA}
                  onClick={(e) => handleNavClick(e, '/torneosPais/' + ARGENTINA)}
                >
                  Torneos
                </a>
                <a
                  href={'/selecciones/' + ARGENTINA}
                  onClick={(e) => handleNavClick(e, '/selecciones/' + ARGENTINA)}
                >
                  Selecciones
                </a>
                <a
                  href={'/clubes?pais=' + ARGENTINA}
                  onClick={(e) => handleNavClick(e, '/clubes?pais=' + ARGENTINA)}
                >
                  Clubes
                </a>
                <a
                  href={'/enfrentamientos?pais=' + ARGENTINA}
                  onClick={(e) => handleNavClick(e, '/enfrentamientos?pais=' + ARGENTINA)}
                >
                  Enfrentamientos
                </a>
              </ul>
            )}
          </li>
          <li>
            <a
              className={usuario === null ? `${styles.disabledLink}` : undefined}
              href="/clubes"
              onClick={(e) => handleNavClick(e, '/clubes')}
            >
              Clubes
            </a>
          </li>
          <li
            className={`${styles.menuConSubmenu}`}
            onMouseEnter={mostrarSubmenu}
            onMouseLeave={ocultarSubmenu}
            onClick={toggleSubmenu}
          >
            <a
              className={usuario === null ? `${styles.disabledLink}` : undefined}
              href="/personas"
              onClick={(e) => handleNavClick(e, '/personas')}
            >
              Personas
            </a>
            {showSubmenu && (
              <ul className={`${styles.submenuContent}`}>
                <a href="/jugadores" onClick={(e) => handleNavClick(e, '/jugadores')}>
                  Jugadores
                </a>
                <a href="/tecnicos" onClick={(e) => handleNavClick(e, '/tecnicos')}>
                  Directores técnicos
                </a>
                <a href="/arbitros" onClick={(e) => handleNavClick(e, '/arbitros')}>
                  Arbitros
                </a>
              </ul>
            )}
          </li>
          <li
            className={`${styles.menuConSubmenu}`}
            onMouseEnter={mostrarSubmenu}
            onMouseLeave={ocultarSubmenu}
            onClick={toggleSubmenu}
          >
            <a
              className={usuario === null ? `${styles.disabledLink}` : undefined}
              href="/torneos"
              onClick={(e) => handleNavClick(e, '/torneos')}
            >
              Torneos
            </a>
            {showSubmenu && (
              <ul className={`${styles.submenuContent}`}>
                <a
                  href="/torneos/nacionales"
                  onClick={(e) => handleNavClick(e, '/torneos/nacionales')}
                >
                  Nacionales
                </a>
                <a
                  href="/torneos/internacionales"
                  onClick={(e) => handleNavClick(e, '/torneos/internacionales')}
                >
                  Internacionales
                </a>
                <a
                  href="/torneos/selecciones"
                  onClick={(e) => handleNavClick(e, '/torneos/selecciones')}
                >
                  Selecciones
                </a>
              </ul>
            )}
          </li>
          {usuario && usuario.puedeEditar && (
            <li
              className={`${styles.submenu}`}
              onMouseEnter={mostrarSubmenu}
              onMouseLeave={ocultarSubmenu}
              onClick={toggleSubmenu}
            >
              Administración
              {showSubmenu && (
                <ul className={`${styles.submenuContent}`}>
                  <a href="/admin/geografia" onClick={(e) => handleNavClick(e, '/admin/geografia')}>
                    Geografía
                  </a>
                  <a href="/admin/estadios" onClick={(e) => handleNavClick(e, '/admin/estadios')}>
                    Estadios
                  </a>
                  <a
                    href="/admin/parametros"
                    onClick={(e) => handleNavClick(e, '/admin/parametros')}
                  >
                    Parametros
                  </a>
                </ul>
              )}
            </li>
          )}
          {usuario && (
            <li className={`${styles.submenu}`} onClick={handlerLogout}>
              Logout
            </li>
          )}
        </ul>
        <div className={`${styles.menuBack}`} />
        <div className={`${styles.contenedor}`}>
          <Routes>
            <Route exact path="/" element={<Inicio modo={modo} />} />
            <Route exact path="/login" element={<Inicio modo={ModoInicio.LOGIN} />} />
            <Route exact path="/logout" element={<Inicio modo={ModoInicio.LOGOUT} />} />
            <Route exact path="/nosession" element={<Inicio modo={ModoInicio.SESION_VENCIDAD} />} />
            <Route path="/clubes" element={<Clubes />} />
            <Route path="/club/:id" element={<DatosClub />} />
            <Route path="/personas" element={<Personas />} />
            <Route path="/persona/:id" element={<DatosPersona />} />
            <Route
              path="/jugadores"
              element={<Personas profesion={Filtros.PathPersona.JUGADORES} />}
            />
            <Route exact path="/jugador/:id" element={<DatosPersona />} />
            <Route
              path="/tecnicos"
              element={<Personas profesion={Filtros.PathPersona.TECNICOS} />}
            />
            <Route exact path="/tecnico/:id" element={<DatosPersona />} />
            <Route
              path="/arbitros"
              element={<Personas profesion={Filtros.PathPersona.ARBITROS} />}
            />
            <Route exact path="/arbitro/:id" element={<DatosPersona />} />
            <Route exact path="/selecciones/:id" element={<SeleccionesPais />} />
            <Route path="/torneos" element={<HomeTorneos />} />
            <Route
              exact
              path="/torneosPais/:idPais"
              element={<RouterTorneos filtro={Filtros.Torneo.PAIS} />}
            />
            <Route
              exact
              path="/torneosInt/:codTipoTorneo"
              element={<RouterTorneos filtro={Filtros.Torneo.TIPO_TORNEO} />}
            />
            <Route
              exact
              path="/torneosPais/:idPais/division/:idDivision"
              element={<RouterTorneos filtro={Filtros.Torneo.DIVISION} />}
            />
            <Route exact path="/torneos/internacionales" element={<HomeTorneosInt />} />
            <Route exact path="/torneos/nacionales" element={<HomeTorneosPaises />} />
            <Route exact path="/torneos/selecciones" element={<HomeTorneosSelec />} />
            <Route
              exact
              path="/torneos/:idTorneo"
              element={<RouterTorneos filtro={Filtros.Torneo.TORNEO} />}
            />
            <Route
              exact
              path="/torneos/:idTorneo/equipo/:idEquipo"
              element={<RouterTorneos filtro={Filtros.Torneo.EQUIPO} />}
            />
            <Route
              exact
              path="/torneos/:idTorneo/etapa/:codEtapa"
              element={<RouterTorneos filtro={Filtros.Torneo.ETAPA} />}
            />
            <Route exact path="/partido/:idPartido" element={<FichaPartido />} />
            <Route exact path="/admin/geografia" element={<Geografia />} />
            <Route exact path="/admin/estadios" element={<Estadios />} />
            <Route exact path="/estadio/:id" element={<DatosEstadio />} />
            <Route exact path="/admin/parametros" element={<Parametros />} />
          </Routes>
        </div>
      </div>
    </UserContext.Provider>
  );
};

export default Menu;
